import { render, staticRenderFns } from "./communityIntegralList.vue?vue&type=template&id=741185da&scoped=true"
import script from "./communityIntegralList.vue?vue&type=script&lang=js"
export * from "./communityIntegralList.vue?vue&type=script&lang=js"
import style0 from "./communityIntegralList.vue?vue&type=style&index=0&id=741185da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741185da",
  null
  
)

export default component.exports